import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none z-50" }
const _hoisted_2 = { class: "w-full max-w-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-12 bg-green-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-white fill-current",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z" })
  ])
], -1)
const _hoisted_4 = { class: "px-4 py-2 -mx-3" }
const _hoisted_5 = { class: "mx-3" }
const _hoisted_6 = { class: "font-semibold text-green-500" }
const _hoisted_7 = { class: "text-sm text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notification = _resolveComponent("Notification")!
  const _component_NotificationGroup = _resolveComponent("NotificationGroup")!
  const _component_AppNavbar = _resolveComponent("AppNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CookieBanner = _resolveComponent("CookieBanner")!
  const _component_WhatsAppWidget = _resolveComponent("WhatsAppWidget")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NotificationGroup, { group: "foo" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Notification, {
              enter: "transform ease-out duration-300 transition",
              "enter-from": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4",
              "enter-to": "translate-y-0 opacity-100 sm:translate-x-0",
              leave: "transition ease-in duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0",
              move: "transition duration-500",
              "move-delay": "delay-300"
            }, {
              default: _withCtx(({ notifications }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications, (notification) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md",
                    key: notification.id
                  }, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(notification.title), 1),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(notification.text), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AppNavbar, { "show-transition": _ctx.showLanding }, null, 8, ["show-transition"]),
    _createVNode(_component_router_view),
    _createVNode(_component_CookieBanner),
    _createVNode(_component_WhatsAppWidget, {
      phoneNumber: "+393758881009",
      message: "Ciao, ti contatto per "
    }),
    _createVNode(_component_AppFooter)
  ], 64))
}